import IWall from 'components/interfaces/IWall';
import IWallMetaData from 'components/interfaces/IWallMetaData';

import {
  SET_IDENTIFIER,
  SET_META_DATA,
  SET_PREVIOUS,
  SET_PROPERTIES,
  SET_RAW,
} from './types';

const initialState = {
  identifier: null,
  metaData: null,
  previous: null,
  properties: null,
  raw: undefined,
};

interface IState {
  identifier: string | null;
  metaData: IWallMetaData | null;
  previous: IWall | null;
  properties: IWall | null;
  raw: any;
}

export default (
  state: IState = initialState,
  action: {
    identifier?: string;
    metaData?: IWallMetaData;
    previous?: IWall;
    properties?: IWall;
    raw?: any;
    type: string;
  }
): IState => {
  if (action.type === SET_IDENTIFIER && action.identifier !== undefined) {
    return {
      ...state,
      identifier: action.identifier,
    };
  }

  if (action.type === SET_META_DATA && action.metaData !== undefined) {
    return {
      ...state,
      metaData: action.metaData,
    };
  }

  if (action.type === SET_PREVIOUS && action.previous !== undefined) {
    return {
      ...state,
      previous: action.previous,
    };
  }

  if (action.type === SET_PROPERTIES && action.properties !== undefined) {
    return {
      ...state,
      properties: action.properties,
    };
  }

  if (action.type === SET_RAW) {
    return {
      ...state,
      raw: action.raw,
    };
  }

  return state;
};
